var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board-canvas relative flex-grow"},[(_vm.pipeline)?_c('div',{key:_vm.projectId,class:[
      'board',
      'absolute',
      'inset-0',
      'select-none',
      'whitespace-nowrap',
      'mb-2',
      'pb-2',
      'px-1',
      'overflow-x-auto',
      'overflow-y-hidden',
    ]},_vm._l((_vm.pipelineStages),function(pipelineStage){return _c('PipelineStage',{key:pipelineStage.id,ref:"pipelineStages",refInFor:true,attrs:{"pipeline":_vm.pipeline,"pipeline-stage":pipelineStage,"last-focused-contact-request":_vm.lastFocusedContactRequest,"assigned-to-me":_vm.assignedToMe,"project-id":_vm.projectId},on:{"edit":_vm.editContactRequest}})}),1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }